import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../../service/udnick';

export const FavoriteServices = {
  favoritaInscricaoEstadual: (codparc: number, favorito: boolean): Promise<AxiosResponse> =>
    UDNICK.callService('favoritaInscricaoEstadual', { codparc, favorito }),
};
